import { MarketplaceTemplateEnrichedWithCreatorName } from '../domain/entities/marketplaceTemplate';
import { useInitialState } from '../contexts/InitialStateContext';
import { useSelectedCategory } from './useSelectedCategory';
import { CATEGORY_SLUGS_TO_MARKETPLACE_TEMPLATE_IDS } from '../config';

export const useMarketplaceTemplates =
  (): MarketplaceTemplateEnrichedWithCreatorName[] => {
    const { marketplaceTemplatesByTemplateId } = useInitialState();
    const { slug } = useSelectedCategory() ?? {};

    if (
      !slug ||
      !Object.keys(CATEGORY_SLUGS_TO_MARKETPLACE_TEMPLATE_IDS).includes(slug)
    ) {
      return [];
    }

    return CATEGORY_SLUGS_TO_MARKETPLACE_TEMPLATE_IDS[slug]
      .map((templatedId) => marketplaceTemplatesByTemplateId[templatedId])
      .filter(Boolean);
  };
